"use client";

import { FC, useState, useEffect } from "react";
import style from "./style.module.scss";
import { IMetarData } from "@/interfaces/Map";
import MetarDetailsItem from "./MetarDetailsItem";
import NoDataSection from "./NoDataSection";
import { MetarDetailsItems, UI_TEXT, CONFIG } from "@/constants";
import { Nullable } from "@/types";

type Props = {
  metar: Nullable<IMetarData[]>;
};

const MetarDetails: FC<Props> = ({ metar }) => {
  const [activeMetar, setActiveMetar] = useState<Nullable<IMetarData>>(
    metar?.[0] || null
  );

  const handleTabClick = (index: number) => {
    if (metar && metar[index]) {
      setActiveMetar(metar[index]);
    }
  };

  const getActiveTabIndex = () => {
    if (!metar || !activeMetar) return -1;
    return metar.findIndex((m) => m === activeMetar);
  };

  useEffect(() => {
    if (metar && metar.length > 0) {
      setActiveMetar(metar[0]);
    }
  }, [metar]);

  return (
    <div className={style.metarDetails}>
      {metar && metar.length > 0 ? (
        <>
          <div className={style.detailsOptionTabs}>
            {metar.map((_, index) => (
              <button
                key={index}
                className={`${style.detailsOptionTabButton} ${
                  getActiveTabIndex() === index
                    ? style.detailsOptionTabButtonActive
                    : ""
                }`}
                onClick={() => handleTabClick(index)}
              >
                {UI_TEXT.TABS.METAR} {index + 1}
              </button>
            ))}
          </div>
          {activeMetar && (
            <>
              <div className={style.metarDetailsHeader}>
                <div className={style.metarDetailsTitleContainer}>
                  <h3 className={style.metarDetailsTitle}>
                    {UI_TEXT.TABS.METAR}:{" "}
                    {activeMetar?.rawMetar.split(
                      CONFIG.RAW_DATA.SPLIT_DELIMITER
                    )[CONFIG.RAW_DATA.ICAO_CODE_INDEX] ?? ""}
                  </h3>
                  <div className={style.metarDetailsTitleCircle} />
                  <span className={style.metarDetailsTitleSub}>
                    {activeMetar?.flightCategory}
                  </span>
                </div>
                <div className={style.metarDetailsDescriptionContainer}>
                  <span className={style.metarDetailsDescription}>
                    {UI_TEXT.LABELS.RAW_METAR}
                  </span>
                  <span className={style.metarDetailsDescription}>
                    {activeMetar?.rawMetar}
                  </span>
                </div>
              </div>
              <div className={style.metarDetailsContent}>
                {MetarDetailsItems.map((item, index) => (
                  <MetarDetailsItem
                    key={index}
                    iconSrc={item.iconSrc}
                    label={item.label}
                    value={item.getValue(activeMetar)}
                  />
                ))}
              </div>
            </>
          )}
        </>
      ) : (
        <NoDataSection />
      )}
    </div>
  );
};

export default MetarDetails;
